const RING_RADIUS = 16;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
const VISIBLE_MIN_PERCENT = 2;

interface ReadingProgressRingProps {
    percent: number;
}

function scrollToTop(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

export default function ReadingProgressRing({ percent }: ReadingProgressRingProps) {
    const clamped = Math.min(100, Math.max(0, percent));

    if (clamped < VISIBLE_MIN_PERCENT) {
        return null;
    }

    const dashOffset = RING_CIRCUMFERENCE * (1 - clamped / 100);

    return (
        <button
            type="button"
            onClick={scrollToTop}
            aria-label={`Scroll to top, ${Math.round(clamped)}% read`}
            className="fixed bottom-8 right-8 z-50 flex h-14 w-14 items-center justify-center rounded-full border-2 border-darkBlue bg-white shadow-lg transition-transform hover:scale-105 dark:border-lightBlue dark:bg-gray-900"
        >
            <svg viewBox="0 0 40 40" className="absolute h-14 w-14 -rotate-90">
                <circle
                    cx="20"
                    cy="20"
                    r={RING_RADIUS}
                    fill="none"
                    strokeWidth="3"
                    stroke="currentColor"
                    className="text-lightGrey dark:text-gray-700"
                />
                <circle
                    cx="20"
                    cy="20"
                    r={RING_RADIUS}
                    fill="none"
                    strokeWidth="3"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeDasharray={RING_CIRCUMFERENCE}
                    strokeDashoffset={dashOffset}
                    className="text-darkBlue transition-[stroke-dashoffset] duration-150 ease-out dark:text-lightBlue"
                />
            </svg>
            <span className="text-xs font-bold tabular-nums text-darkBlue dark:text-lightBlue">
                {Math.round(clamped)}%
            </span>
        </button>
    );
}
